module.exports = __webpack_public_path__ + "static/media/22ESCWA22.3d157e5b.jpg";